module.exports = __webpack_public_path__ + "static/media/rcsi.9d7793e8.png";